(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kecent-premium-detail-tabs"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-kecent-tabs]').forEach(root => {
  const tabs = [...root.querySelectorAll('[data-kecent-tab]')];
  const panels = [...root.querySelectorAll('[data-kecent-panel]')];
  if (!tabs.length || tabs.length !== panels.length) return;
  root.querySelector('nav').setAttribute('role', 'tablist');
  const activate = (index, focus = false) => {
    tabs.forEach((tab, i) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', String(i === index));
      tab.setAttribute('tabindex', i === index ? '0' : '-1');
      tab.setAttribute('aria-controls', panels[i].id);
      panels[i].hidden = i !== index;
      panels[i].setAttribute('role', 'tabpanel');
      if (focus && i === index) tab.focus();
    });
  };
  tabs.forEach((tab, i) => {
    tab.addEventListener('click', event => { event.preventDefault(); activate(i); });
    tab.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      activate(next, true);
    });
  });
  root.querySelector('[data-kecent-to-details]')?.addEventListener('click', event => { event.preventDefault(); activate(0); });
  activate(0);
});
document.querySelectorAll('[data-kecent-description]').forEach(description => {
  const images = [...description.querySelectorAll('img')];
  const button = description.querySelector('[data-kecent-more]');
  if (!button || images.length <= 4) return;
  const extra = images.slice(4).map(image => {
    const paragraph = image.parentElement;
    return paragraph?.tagName === 'P' && paragraph.children.length === 1 && !paragraph.textContent.trim() ? paragraph : image;
  });
  const setExpanded = expanded => {
    extra.forEach(element => { element.hidden = !expanded; });
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel + ' (' + images.length + ')';
  };
  button.hidden = false;
  button.addEventListener('click', () => setExpanded(button.getAttribute('aria-expanded') !== 'true'));
  setExpanded(false);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kecent-product-detail-tabs"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-kecent-tabs]').forEach(root => {

  const tabs = [...root.querySelectorAll('[data-kecent-tab]')];

  const panels = [...root.querySelectorAll('[data-kecent-panel]')];

  if (!tabs.length || tabs.length !== panels.length) return;

  root.querySelector('nav').setAttribute('role', 'tablist');

  const activate = (index, focus = false) => {

    tabs.forEach((tab, i) => {

      tab.setAttribute('role', 'tab');

      tab.setAttribute('aria-selected', String(i === index));

      tab.setAttribute('tabindex', i === index ? '0' : '-1');

      tab.setAttribute('aria-controls', panels[i].id);

      panels[i].hidden = i !== index;

      panels[i].setAttribute('role', 'tabpanel');

      if (focus && i === index) tab.focus();

    });

  };

  tabs.forEach((tab, i) => {

    tab.addEventListener('click', event => { event.preventDefault(); activate(i); });

    tab.addEventListener('keydown', event => {

      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      event.preventDefault();

      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;

      activate(next, true);

    });

  });

  root.querySelector('[data-kecent-to-details]')?.addEventListener('click', event => { event.preventDefault(); activate(0); });

  activate(0);

});

document.querySelectorAll('[data-kecent-description]').forEach(description => {

  const images = [...description.querySelectorAll('img')];

  const button = description.querySelector('[data-kecent-more]');

  if (!button || images.length <= 4) return;

  const extra = images.slice(4).map(image => {

    const paragraph = image.parentElement;

    return paragraph?.tagName === 'P' && paragraph.children.length === 1 && !paragraph.textContent.trim() ? paragraph : image;

  });

  const setExpanded = expanded => {

    extra.forEach(element => { element.hidden = !expanded; });

    button.setAttribute('aria-expanded', String(expanded));

    button.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel + ' (' + images.length + ')';

  };

  button.hidden = false;

  button.addEventListener('click', () => setExpanded(button.getAttribute('aria-expanded') !== 'true'));

  setExpanded(false);

});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    document.querySelectorAll('.kc-language-switcher[open]').forEach((switcher) => {
      if (!switcher.contains(event.target)) switcher.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const switcher = event.target instanceof Element ? event.target.closest('.kc-language-switcher[open]') : null;
    if (!switcher) return;
    switcher.removeAttribute('open');
    switcher.querySelector('summary')?.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
